import React, { Component } from 'react'
import { findPeople, follow } from './apiUser';
import { Link } from 'react-router-dom';
import DefaultProfile from '../assets/avatar.jpg';
import { isAuthenticated } from '../auth';

class FindPeople extends Component {
    constructor() {
        super()
        this.state = {
            users: [],
            error: '',
            open: false
        }
    }

    componentDidMount() {
        const userId = isAuthenticated().user._id;
        const token = isAuthenticated().token;
        findPeople(userId, token).then(data => {
            if (data.error) {
                console.log(data.error);
            } else {
                this.setState({ users: data });
            }
        });
    }

    /* 
    const lDate = Date.now();
    const photoUrl = user._id ? `${process.env.REACT_APP_API_URL}/user/photo/${user._id}?v=${lDate}` : DefaultProfile;
    */

    clickFollow = (user, index) => {
        const userId = isAuthenticated().user._id;
        const token = isAuthenticated().token;

        //follow(userId, token, this.state.users[index])
        follow(userId, token, user._id)
        .then(data => {
            if(data.error){
                this.setState({error: data.error});
            }else{
                let toFollow = this.state.users;
                toFollow.splice(index, 1);
                this.setState({
                    users: toFollow,
                    open: true,
                    followMessage: `Now following ${user.name}!`
                })
            }
        })
    }

    renderUsers = users => (
        <div className="row">
            {users.map((user, i) => (
                <div className="card col-md-3 col-sm-6 mb-4" key={i}>
                    <img
                        className="card-img-top rounded-circle mt-4 img-thumbnail"
                        style={{ width: 'auto', maxHeight: '200px', margin: 'auto'}}
                        src={`${process.env.REACT_APP_API_URL}/user/photo/${user._id}`}
                        onError={i => (i.target.src = `${DefaultProfile}`)}
                        alt={user.name}
                    />
                    <div className="card-body">
                        <h5 className="card-title">{user.name}</h5>
                        <p className="card-text">
                            {user.email}
                        </p>
                        <Link to={`/user/${user._id}`} className="btn btn-raised btn-primary btn-sm">View Profile</Link>

                        <button onClick={() => this.clickFollow(user, i)} className="btn btn-raised btn-info float-right btn-sm">
                            Follow
                        </button>

                    </div>
                </div>
            ))}
        </div>
    )

    render() {
        const { users, open } = this.state;
        return (
            <div className="container">
                <h2 className="mt-5">Find Users</h2>
                {open && <p className="alert alert-success" role="alert">{this.state.followMessage}</p>}
                {this.renderUsers(users)}
            </div>
        )
    }
}

export default FindPeople;
